export default ['home', 'about', 'work', 'skills', 'contact']